"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupsToSequence = groupsToSequence;
const groupsObject_js_1 = require("./groupsObject.js");
/**
 * Recreate a one letter sequence
 * @param {object} mf
 */
function groupsToSequence(mf) {
    mf = mf.replaceAll(/\([^(]*\)/g, '');
    let parts = mf.split(/(?=[ A-Z])/);
    let usefulParts = [];
    for (let part of parts) {
        if (part === ' ') {
            usefulParts.push(' ');
            continue;
        }
        if (!part.match(/^[A-Z][a-z]{2,6}/))
            continue;
        if (groupsObject_js_1.groupsObject[part] && groupsObject_js_1.groupsObject[part].oneLetter) {
            usefulParts.push(groupsObject_js_1.groupsObject[part].oneLetter);
        }
        else {
            usefulParts.push('?');
        }
    }
    return usefulParts.join('').replaceAll(/ +/g, ' ').trim();
}
//# sourceMappingURL=groupsToSequence.js.map